import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'IronScales/Dashboard/Home/Deepfake'

export const CREATE_DEEPFAKE_ANALYTIC_ASYNC = createAsyncTypes('CREATE_DEEPFAKE_ANALYTIC', typeKey)
